// Request/response bodies carry API tokens, carrier credentials and shopper
// PII, and there is no endpoint we can vouch for as free of them. Bodies are
// therefore never sent to LogRocket; only metadata (method, URL, status,
// timing) is kept.

const REDACTED_HEADERS = [
  'seller-store-guid',
  'rr-store-id',
  'authorization',
  'cookie',
  'set-cookie'
];

function sanitizeHeaders(headers) {
  if (!headers) return headers;

  return Object.keys(headers).reduce((acc, name) => {
    acc[name] = REDACTED_HEADERS.includes(name.toLowerCase())
      ? '*'
      : headers[name];
    return acc;
  }, {});
}

/**
 * @param {import('logrocket').IRequest} request
 */
export function requestSanitizer(request) {
  request.body = null;
  request.headers = sanitizeHeaders(request.headers);
  return request;
}

/**
 * @param {import('logrocket').IResponse} response
 */
export function responseSanitizer(response) {
  response.body = null;
  response.headers = sanitizeHeaders(response.headers);
  return response;
}
